import { useState } from 'react';
import { walletService } from '@/services/api/walletService/walletService';
import { WALLET_PHRASES } from '@/consts/phrases/walletPhrases';
import { usePhrase } from '@/hooks/general/usePhrase/usePhrase';
import { DownloadFileIcon } from '@/assets/theme/default/general/DownloadFileIcon';
import { Button } from '@mui/material';

export const InvoiceFileButton = ({ invoiceFileApiUrl }: { invoiceFileApiUrl: string }) => {
    const { t } = usePhrase();
    const [isGettingFileLink, setIsGettingFileLink] = useState(false);

    const downloadInvoiceFile = async () => {
        setIsGettingFileLink(true);
        const { presignedInvoiceURL } =
            await walletService.getInvoiceDownloadLink(invoiceFileApiUrl);
        setIsGettingFileLink(false);
        window.open(presignedInvoiceURL);
    };

    return (
        <Button
            onClick={downloadInvoiceFile}
            size="small"
            variant="outlined"
            sx={{ fontSize: '0.875rem' }}
            loading={isGettingFileLink}
            disabled={isGettingFileLink}
        >
            <DownloadFileIcon />
            {t(WALLET_PHRASES.DOWNLOAD)}
        </Button>
    );
};
